import React, { lazy } from 'react';
import MiniprogramErrorIcon from '@/assets/images/menu/icon-hippy-error.react.svg?react';
import MiniprogramEventIcon from '@/assets/images/menu/icon-hippy-event.react.svg?react';
import MiniprogramLogIcon from '@/assets/images/menu/icon-hippy-log.react.svg?react';
import MiniprogramPvIcon from '@/assets/images/menu/icon-hippy-pv.react.svg?react';
import MiniprogramSpeedIcon from '@/assets/images/menu/icon-hippy-speed.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';


export const reactNativeRoutes = (): IRouteConfig[] => [
  {
    path: '/react-native/error',
    name: '错误监控',
    component: lazy(() => import('@/presentation/pages/react-native/error')),
    icon: <MenuIcon icon={MiniprogramErrorIcon} fontSize={16} />,
    platforms: [CapitalPlatform.ReactNative],
  },
  {
    path: '/react-native/pv',
    name: '页面访问',
    icon: <MenuIcon icon={MiniprogramPvIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/react-native/pv')),
    platforms: [CapitalPlatform.ReactNative],
  },
  {
    path: '/react-native/event',
    name: '自定义事件',
    icon: <MenuIcon icon={MiniprogramEventIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/react-native/event')),
    platforms: [CapitalPlatform.ReactNative],
  },
  {
    path: '/react-native/custom',
    name: '自定义测速',
    icon: <MenuIcon icon={MiniprogramSpeedIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/react-native/custom')),
    platforms: [CapitalPlatform.ReactNative],
  },
  {
    path: '/react-native/log',
    name: '日志',
    icon: <MenuIcon icon={MiniprogramLogIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/react-native/log')),
    platforms: [CapitalPlatform.ReactNative],
  },
];

export default reactNativeRoutes;
